import { render, staticRenderFns } from "./ColorSwatchPicker.vue?vue&type=template&id=307ef2aa"
import script from "./ColorSwatchPicker.vue?vue&type=script&lang=js"
export * from "./ColorSwatchPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports